// Leaf module: keep it import-free. `actions/logoutCandidate` imports it, and
// any dependency on the component/hook/provider graph closes a cycle through
// the actions barrel.

// Module-level rather than a ref: the reports page remounts after re-login,
// so a component ref would forget that logout hid the launcher.
let hiddenForLogout = false;

export const isHiddenForLogout = () => hiddenForLogout;

/** Lets a newer hide (modal, `useHideChat`) take ownership of visibility. */
export const clearHiddenForLogout = () => {
  hiddenForLogout = false;
};

// Replaces the signed-in payload so the hidden widget no longer holds the
// previous candidate's access token.
const LOGGED_OUT_DECAGON_METADATA = { cxUserAccessToken: null };

/**
 * Dismisses Decagon on logout. The embed is mounted on document.body, so it
 * would otherwise stay on the sign-in screen. Ada is left alone: `useAda`
 * does not restart it on the next SPA login. Synchronous, so a caller's
 * try/catch sees every error.
 *
 * The metadata is cleared even if hide/close throw. Decagon exposes no way
 * to clear `setUserId`/`setUserIdAuth`, so the previous identity stays on
 * the instance until the next successful auth overwrites it; the widget
 * stays hidden until then because only `restoreChatAfterLogout` can undo
 * this hide.
 */
export const hideDecagonForLogout = () => {
  hiddenForLogout = true;
  try {
    globalThis.duet?.hide?.();
    globalThis.duet?.close?.();
  } finally {
    globalThis.duet?.setMetadata?.(LOGGED_OUT_DECAGON_METADATA);
  }
};

/**
 * Undoes a logout-driven hide. A no-op otherwise, so it never overrides a
 * hide owned by a modal or `useHideChat` (ECDEX-2707).
 */
export const restoreChatAfterLogout = () => {
  if (!hiddenForLogout) return;
  hiddenForLogout = false;
  globalThis.duet?.unhide?.();
};
